/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by randysorensen on 8/16/16.
 */

'use strict';
angular
	.module('prism-ui.components.data')
	.service('MetadataEditService',
		function(_, $q, MetaPropsResourceFactory, MetaGroupsResourceFactory)
{
	var self = this;

	self.serviceReady = undefined;

	var rawGroups = [ ];
	var groupsBy;
	var groupsByOwnerClass = { };

	var getMetadataGroupsList = function (deferred) {
		MetaGroupsResourceFactory.query(function (metaGroups) {
			rawGroups = metaGroups;
			deferred.resolve(metaGroups);
		});
		return deferred.promise;
	};

	var buildLookupMaps = function(objects) {
		var by = {
			id: { },
			name: { }
		};
		angular.forEach(objects, function(object) {
			by.name[object.name] = object;
			by.id[object.id] = object;
		});
		return by;
	};

	var buildGroupOwnerClassMap = function(groups) {
		var classMap = {
			package: [ ],
			nonPackage: [ ],
			partner: [ ]
		};

		angular.forEach(groups, function(group) {
			if (group.name.indexOf('Package') > -1 && group.name.indexOf('Partner') === -1) {
				classMap.package.push(group.name);
			}
			else if (group.name.indexOf('Partner') < 0) {
				classMap.nonPackage.push(group.name);
			}
			else if (group.name.indexOf('Package') === -1){
				classMap.partner.push(group.name);
			}
		});

		return classMap;
	};

	var initialize = function() {
		if (self.serviceReady === undefined) {
			var groupsPromise = getMetadataGroupsList($q.defer());
			self.serviceReady = $q.defer();
			groupsPromise.then(function (rawGroupList) {
				groupsBy = buildLookupMaps(rawGroupList);
				groupsByOwnerClass = buildGroupOwnerClassMap(rawGroupList);
				self.serviceReady.resolve(true);
			});
		}
	};


	// public API

	self.getPropertyById = function (id) {
		return MetaPropsResourceFactory.get({id:id}).$promise;
	};

	self.saveProperty = function(prop) {
		return MetaPropsResourceFactory.save(prop).$promise;
	};

	self.deleteProperty = function(prop) {
		return MetaPropsResourceFactory.delete({id:prop.id}).$promise;
	};

	self.getGroupIdsByNames = function(names) {
		initialize();
		return self.serviceReady.promise.then(function() {
			var groupIdsByNames = [];
			_.forEach(names, function (name) {
				groupIdsByNames.push(groupsBy.name[name].id);
			});

			return groupIdsByNames;
		});
	};

	self.getGroupNamesByIds = function(ids) {
		initialize();
		return self.serviceReady.promise.then(function() {
			var groupsNamesByIds = [];
			_.forEach(ids, function (id) {
				groupsNamesByIds.push(groupsBy.id[id].name);
			});

			return groupsNamesByIds;
		});
	};

	self.getGroupList = function(ownerClass) {
		initialize();
		return self.serviceReady.promise.then(function() {
			return groupsByOwnerClass[ownerClass];
		});
	};

	self.getMetadataByGroup = function (groupName) {
		initialize();
		return self.serviceReady.promise.then(function () {
			return MetaPropsResourceFactory.query().$promise.then(function (properties) {
				return _.remove(properties, function (property) {
					return _.includes(property.groupIds, _.get(_.get(groupsBy.name, groupName), 'id'));
				});
			});
		});
	};
});
